module.exports = __webpack_public_path__ + "static/media/phone.bc9a7c03.svg";